// @ts-check
/**
 * Cookie Notice Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cookie Notice template.
 * This will only work in modern browsers that have support for .mjs files
 */
import Cookies from "./script-js.cookie.mjs";

if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.cookieNotice = () => {
  /**
   * @var {string}
   * The name of the cookie
   * Note: changing this name will reset it and all users will have to opt in again
   */
  const cookieName = "and-daughter-cookies-opt-in-SEP-2021";

  /**
   * @var {number}
   * How long in days should the cookie last
   */
  const cookieLengthInDays = 365;

  /**
   * @var {Record<string, string>}
   * CSS/querySelector selectors
   */
  const selectors = {
    optInButton: "[data-js-cookie-notice-dismiss]",
    overlay: "[data-js-cookie-notice-overlay]",
  };

  /**
   * @var {Record<string, string>}
   * CSS hooks
   */
  const classes = {
    cookieNotice: "._cookie-notice",
    isActive: "is-active",
  };

  /**
   * @var {number}
   * how long to wait in milliseconds before showing the cookie notice
   */
  const timerDelay = 3000;

  /**
   * when the user clicks the close button set a cookie for 1 year hide the message
   */
  const optInOnClick = () => {
    document
      .querySelector(selectors.optInButton)
      ?.removeEventListener("click", optIn);
    document
      .querySelector(selectors.optInButton)
      ?.addEventListener("click", optIn);
  };

  /**
   * User has not got a valid opt in message so show the cookie notice delay it a bit so it's not like rar in the user's face on load
   */
  const showNotice = () => {
    setTimeout(function () {
      document
        .querySelector(classes.cookieNotice)
        ?.classList.add(classes.isActive);

      // Make rest of the page inactive in overlay mode
      if (document.querySelector(selectors.overlay)) {
        document
          .querySelectorAll("header, footer, main")
          .forEach((element) => element.setAttribute("inert", ""));
      }
    }, timerDelay);
  };

  /**
   * Has the user opted in to cookies?
   *
   * @return {boolean}
   */
  const isOptIn = () => {
    const cookieValue = Cookies.get(cookieName);
    let isOptIn = false;

    if (cookieValue && cookieValue.toString() === "true") {
      isOptIn = true;
    }

    return isOptIn;
  };

  /**
   * Handle an optIn request
   *
   * @return {void}
   */
  const optIn = () => {
    document
      .querySelector(classes.cookieNotice)
      ?.classList.remove(classes.isActive);

    // Make rest of the page interactive again in overlay mode
    if (document.querySelector(selectors.overlay)) {
      document
        .querySelectorAll("header, footer, main")
        .forEach((element) => element.removeAttribute("inert"));
    }
    setCookie();
    startAdroll();
  };

  /**
   * Create the cookie
   */
  const setCookie = () => {
    const cookieValue = "true";

    Cookies.set(cookieName, cookieValue, {
      expires: cookieLengthInDays,
      sameSite: "strict",
    });
  };

  /**
   * Add script for Adroll to the oage and start tracking
   */
  const startAdroll = () => {
    if (adroll_pix_id && adroll_adv_id && isOptIn()) {
      (function (w, d, e, o, a) {
        w.__adroll_loaded = true;
        w.adroll = w.adroll || [];
        w.adroll.f = ["setProperties", "identify", "track"];
        var roundtripUrl =
          "https://s.adroll.com/j/" + adroll_adv_id + "/roundtrip.js";
        for (a = 0; a < w.adroll.f.length; a++) {
          w.adroll[w.adroll.f[a]] =
            w.adroll[w.adroll.f[a]] ||
            (function (n) {
              return function () {
                w.adroll.push([n, arguments]);
              };
            })(w.adroll.f[a]);
        }
        e = d.createElement("script");
        o = d.getElementsByTagName("script")[0];
        e.async = 1;
        e.src = roundtripUrl;
        e.onload = function () {
          // Let everyone know adroll has been added
          var event = new CustomEvent("adroll-added", {});
          w.dispatchEvent(event);
        };
        o.parentNode.insertBefore(e, o);
      })(window, document);
      adroll.track("pageView");
    }
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @return {void}
   */
  const init = () => {
    // Don't show if the client hasn't set it up in Theme Customizer
    if (!document.querySelector(classes.cookieNotice) || !Cookies) {
      return;
    }

    // Don't show in non-production environments
    if (window.location.hostname !== "www.and-daughter.com") {
      console.log(
        "The cookie notice is not displayed in non-production environments"
      );
      return;
    }

    // if opt in cookie doesn't exist - show the message
    if (!isOptIn()) {
      showNotice();
    }

    optInOnClick();
    startAdroll();
  };

  return { init };
};

window.AndDaughter.cookieNotice().init();
